import { isAxiosError } from 'axios'
import type { ReactNode } from 'react'
import { useParams } from 'react-router'

import { SkeletonRows } from '@/components/ui/skeleton'
import { type PolicyChangeRequest, usePolicyChange } from '@/models/policyChange'
import { useCurrentUser } from '@/models/user'
import { PolicyChangesGate } from './PolicyChangesGate'

/** Loads the request in the address, behind the policy change gate, and renders it once it's here. */
export function LoadedPolicyChange({
  children,
}: {
  children: (request: PolicyChangeRequest, orgId: string) => ReactNode
}) {
  const { requestId } = useParams<{ requestId: string }>()
  const { user } = useCurrentUser({ enabled: true })
  const { data: request, isLoading, error } = usePolicyChange(user?.currentOrg.id, requestId)

  const missing = isAxiosError(error) && error.response?.status === 404

  let page
  if (isLoading || !user) page = <SkeletonRows className="mt-10" rows={6} />
  else if (!request) {
    page = (
      <div className="mt-10 text-center">
        {missing ? 'Request not found' : 'We couldn’t load this request. Refresh to try again.'}
      </div>
    )
  } else page = children(request, user.currentOrg.id)
  return <PolicyChangesGate>{page}</PolicyChangesGate>
}
